export function Release_2_1() {
    return (
      <div>
        <h2 className="text-sm text-gray-400">Release on: 20 September 2025</h2>
        <h2 className="text-xl font-semibold text-purple-300">Overview</h2>
        <p className="text-gray-200">
              CashMate 2.1 represents a significant leap forward in our mission to provide comprehensive business management solutions for SMEs in Malaysia. 
              This release introduces powerful new features, enhanced performance, and improved user experience across all modules, making it easier than 
              ever to manage your business operations efficiently while staying compliant and consistently adding new features.
            </p>
  
        <h2 className="text-xl font-semibold text-purple-300 mt-6">New Features</h2>
        <h3 className = 'text-lg font-semibold text-gray-400 mt-3'>*Security Enhancemnet</h3>
        <h3 className="text-lg font-semibold text-white mt-3">Online Ordering</h3>
        <ul className="list-disc list-inside">
            <li>User can now open online ordering to let the customer order for pickup.</li>
            <li>Online ordering fucntions can be access through <span className="font-bold">Settings -{">"} Company Settings -{">"} Online Ordering</span>.</li>
            <li>Current payment method is 'Pay At Counter'. More payment method comming soon</li>
            <li>The online order will be display in preorder/kitchen display</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Cashier</h3>
        <ul className="list-disc list-inside">
            <li>User can now pay customer from online orders.</li>
            <li>User now can scan barcode using barcode scanner or camera or type it manually.</li>
            <li>New mode introduced to non-fnb stall type</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Inventory Management</h3>
        <ul className="list-disc list-inside">
            <li>Real-time inventory deduction upon sale or order saving, including smart logic to avoid double deduction on previously saved orders.</li>
            <li>User can set the item to be visible for online ordering.</li>
            <li>User can scan barcode to save it to the product using barcode scanner or camera or type it manually.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Preorder Display</h3>
        <ul className="list-disc list-inside">
            <li>Now if the stall type is fnb, it will display kitchen display otherwise it will display preorder display.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Resolved Issues</h2>
        <ul className="list-disc list-inside">
            <li>UI enhancement.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Known Issues</h2>
        <ul className="list-disc list-inside">
            <li>If the user select online order to pay and add more item in the cart it will not deduct the new item added.</li>
            <li>Accounting related transactions is not sync with any reports, for now it is only for recording purpose.</li>
            <li>Import feature is not available until future update.</li>
            <li>Some pages may have issue in mobile view.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Compatible Devices</h2>
        <ul className="list-disc list-inside">
            <li>Best view on desktop and tablet size.</li>
            <li>Compatible with all devices running on Chrome, Firefox, Safari, and Edge.</li>
        </ul>
      </div>
      
    );
  }
